module.exports = __webpack_public_path__ + "res/20-img_play.33b45725886e655f479697d1c01f1e6f.png";